import urljoin from 'url-join';
import axios from 'axios';

var SERVER_NAME = 'account';
var HOST = process.env.HOST || 'http://testapi.sayyoo.cn';
var baseURL = /*#__PURE__*/urljoin(HOST, SERVER_NAME);
var ins = /*#__PURE__*/axios.create({
  baseURL: baseURL
});

var UserApi;

(function (UserApi) {
  var _basePath = '/user';
  var _host = HOST;

  function setHost(host) {
    _host = host;
  }

  UserApi.setHost = setHost;

  function g() {
    return urljoin(_host, SERVER_NAME, _basePath);
  }

  function getInfoAndIDcard(userid) {
    return ins.get(g() + ("/info/cert/" + userid));
  }

  UserApi.getInfoAndIDcard = getInfoAndIDcard;
})(UserApi || (UserApi = {}));

export { UserApi };
//# sourceMappingURL=services-account.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sayyoo/services-account/dist/services-account.esm.js
// module id = sInM
// module chunks = 256